export const videos: { url: string; poster: string }[] = [
	{
		url: 'https://public.credit.club/site/videos/savings-yan-art.mp4',
		poster: '/images/video-posters/photo_2024-10-02_09-24-52.jpg',
	},
	{
		url: 'https://public.credit.club/site/videos/savings-passive-income.mp4',
		poster: '/images/video-posters/passive-income.jpg',
	},
	{
		url: 'https://public.credit.club/site/videos/savings-invesments-10000-rubles.mp4',
		poster: '/images/video-posters/invest.png',
	},
]
